import React, { useState, useEffect } from 'react'
import moment from 'moment'
import { useIntl } from 'umi'
import { Select, DatePicker, TimePicker } from 'tea-component'

import useConstants from '../../_config/constant'
import DateSelect from '../DateSelect';

const getMomentValue = (time, format) => {
  const momentValue = moment(time, format)
  return momentValue.isValid() ? momentValue : moment()
}

const PushFrequency = (props) => {
  const {
    value: valueProps = {},
    onChange
  } = props
  const { formatMessage } = useIntl()
  const {
    OPTIONS_TIME,
    OPTIONS_DATE,
    OPTIONS_WEEK,
    OPTIONS_FREQUENCY,
    FREQUENCY_TYPE,
    DATE_FORMAT,
    MONTH_FORMAT,
    HOUR_FORMAT,
    DEFAULT_FREQUNCY_VALUE,
    FREQUENCY_KEY_MAP
  } = useConstants({ formatMessage })
  const {
    NOW,
    ONE,
    HOUR,
    DAY,
    WEEK,
    MONTH,
  } = FREQUENCY_TYPE
  const { type, ...rest } = valueProps
  const [frequencyType, setFrequencyType] = useState(String(type) ?? NOW)
  const [value, setValue] = useState(rest ?? {})

  const handleChange = (pickerValue) => {
    setValue({
      ...value,
      ...pickerValue
    })
    onChange?.({
      type: frequencyType,
      ...value,
      ...pickerValue
    })
  }

  // 推送频率变化
  const handleTypeChange = (type) => {
    setFrequencyType(type)
    const frequncyValue = {
      type,
      ...(DEFAULT_FREQUNCY_VALUE[type] ?? {})
    }

    onChange?.(frequncyValue)
    setValue(frequncyValue)
  }

  // 按不同推送频率建立组件映射
  const frequencyComponentMap = {
    [NOW]: <></>,
    [ONE]: (
      <>
        <DatePicker
          className="form-item-select"
          value={moment(value[FREQUENCY_KEY_MAP[ONE][0]])}
          onChange={value => handleChange({ [FREQUENCY_KEY_MAP[ONE][0]]: moment(value).format(DATE_FORMAT) })}
        // onOpenChange={open => console.log(open ? 'open' : 'close')}
        />
        <TimePicker
          className="form-item-select"
          value={getMomentValue(value[FREQUENCY_KEY_MAP[ONE][1]], HOUR_FORMAT)}
          format='HH:mm'
          onChange={value => handleChange({ [FREQUENCY_KEY_MAP[ONE][1]]: moment(value).format(HOUR_FORMAT) })}
        />
      </>
    ),
    [HOUR]: (
      <DateSelect
        className="form-item-select dbd-form-item-select-hour"
        value={value[FREQUENCY_KEY_MAP[HOUR][0]] ?? []}
        optionsDate={OPTIONS_TIME}
        searchable={true}
        placeholder={formatMessage({ id: 'subscribe_setting_input_placeholder_frequency' })}
        boxClassName='subscription-setting-date-select__dropdown--time'
        onChange={value => handleChange({ [FREQUENCY_KEY_MAP[HOUR][0]]: value?.filter(item => item) })}
      />
    ),
    [DAY]: (
      <TimePicker
        className="form-item-select"
        value={getMomentValue(value[FREQUENCY_KEY_MAP[DAY][0]], HOUR_FORMAT)}
        format='HH:mm'
        onChange={value => handleChange({ [FREQUENCY_KEY_MAP[DAY][0]]: moment(value).format(HOUR_FORMAT) })}
      />
    ),
    [WEEK]: (
      <>
        <DateSelect
          className="form-item-select"
          value={value[FREQUENCY_KEY_MAP[WEEK][0]] ?? []}
          optionsDate={OPTIONS_WEEK}
          placeholder={formatMessage({ id: 'subscribe_setting_input_placeholder_frequency' })}
          onChange={value => handleChange({ [FREQUENCY_KEY_MAP[WEEK][0]]: value?.filter(item => item)?.sort((a, b) => a - b) })}
        />
        <TimePicker
          className="form-item-select"
          value={getMomentValue(value[FREQUENCY_KEY_MAP[WEEK][1]], HOUR_FORMAT)}
          format='HH:mm'
          onChange={value => handleChange({ [FREQUENCY_KEY_MAP[WEEK][1]]: moment(value).format(HOUR_FORMAT) })}
        />
      </>
    ),
    [MONTH]: (
      <>
        <DateSelect
          className="form-item-select"
          value={value[FREQUENCY_KEY_MAP[MONTH][0]] ?? []}
          optionsDate={OPTIONS_DATE}
          searchable={true}
          placeholder={formatMessage({ id: 'subscribe_setting_input_placeholder_frequency' })}
          boxClassName="subscription-setting-date-select__dropdown--date"
          onChange={value => handleChange({ [FREQUENCY_KEY_MAP[MONTH][0]]: value?.filter(item => item)?.sort((a, b) => a - b) })}
        />
        <TimePicker
          className="form-item-select"
          value={getMomentValue(value[FREQUENCY_KEY_MAP[MONTH][1]], HOUR_FORMAT)}
          format='HH:mm'
          onChange={value => handleChange({ [FREQUENCY_KEY_MAP[MONTH][1]]: moment(value).format(HOUR_FORMAT) })}
        />
      </>
    ),
  }

  useEffect(() => {
    const { type, ...rest } = valueProps
    setValue(rest ?? {})
    setFrequencyType(String(type))
  }, [valueProps])

  return (
    <>
      <Select
        // boxClassName='subscription-setting__fequency-dropdown'
        className="form-item-select js-guide-subscribesetting-frequency-select"
        value={frequencyType}
        appearance='button'
        options={OPTIONS_FREQUENCY}
        onChange={handleTypeChange}
        placeholder=''
        matchButtonWidth
      />
      {frequencyComponentMap[frequencyType]}
    </>
  )
}

export default PushFrequency
